import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
  table-layout: fixed;
`
